import React from 'react';

import Apply from './Apply';
import LayoutGrid from '../../components/LayoutGrid';

async function action() {
  return {
    component: (
      <LayoutGrid>
        <Apply />
      </LayoutGrid>
    ),
  };
}

export default action;
